export default __webpack_public_path__ + "static/media/monto_verde.e14961ba.svg";